import { Map, List, fromJS } from 'immutable'
import createReucer from '@/models/createReucer'
import {
  TENANT_LIST_FETCHED,
  TENANT_CREATED,
  TENANT_UPDATED,
  TOGGLE_LOADING,
  STAFF_CONVS_FETCHED
} from './actionTypes'

const initializeState = Map({
  entries: List(),
  fetching: false,
  total: 0
})

export default createReucer({
  [TOGGLE_LOADING]: (state) => state.update('fetching', fetching => !fetching),

  [TENANT_LIST_FETCHED]: (state, { payload }) => {
    const { total, data } = payload

    return state
      .set('total', total)
      .set('entries', List(fromJS(data)))
  },
  [STAFF_CONVS_FETCHED]: (state, { payload }) => {
    const { data } = payload
    return state
      .set('staff_convs', List(fromJS(data)))
  },
  
  [TENANT_CREATED]: (state, { payload }) =>
    state
      .update('total', total => total+1)
      .update('entries', entries => entries.unshift(new Map(payload))),

  [TENANT_UPDATED]: (state, { payload }) =>
    state.update(
      'entries',
      list =>
        list.update(
          list.findIndex(item => item.get('_id') === payload.id),
          item => item.merge(payload.data)
        )
    )
}, initializeState)
